import React, { useState, useEffect } from 'react';
import MobileHeader from './MobileHeader';
import MobileTabs, { TabType } from './MobileTabs';
import PoliciesTab from './PoliciesTab';
import AIBotTab from './AIBotTab';
import { Policy } from '../../services/firestoreService';

interface Message {
  id: string;
  content: string;
  sender: 'user' | 'ai';
  timestamp: Date;
  isTyping?: boolean;
}

interface MobileLayoutProps {
  policies: Policy[];
  messages: Message[];
  setMessages: React.Dispatch<React.SetStateAction<Message[]>>;
  inputMessage: string;
  setInputMessage: React.Dispatch<React.SetStateAction<string>>;
  typeMessage: (messageId: string, fullText: string) => void;
  handleSendMessage: (e: React.FormEvent) => Promise<void>;
  quickQuestions: string[];
  scrollPosition: number;
  scrollContainerRef: React.RefObject<HTMLDivElement>;
  scrollQuestions: (direction: 'left' | 'right') => void;
  chatContainerRef: React.RefObject<HTMLDivElement>;
  isUserScrolling: boolean;
  shouldAutoScroll: boolean;
  handleScroll: () => void;
  scrollToBottom: (force?: boolean) => void;
  isAIReplying: boolean;
}

const MobileLayout: React.FC<MobileLayoutProps> = ({
  policies,
  messages,
  setMessages,
  inputMessage,
  setInputMessage,
  typeMessage,
  handleSendMessage,
  quickQuestions,
  scrollPosition,
  scrollContainerRef,
  scrollQuestions,
  chatContainerRef,
  isUserScrolling,
  shouldAutoScroll,
  handleScroll,
  scrollToBottom,
  isAIReplying
}) => {
  const [activeTab, setActiveTab] = useState<TabType>('ai-bot');
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // 設置手機瀏覽器視窗高度
  useEffect(() => {
    const setVH = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    };

    setVH();
    window.addEventListener('resize', setVH);
    window.addEventListener('orientationchange', setVH);

    return () => {
      window.removeEventListener('resize', setVH);
      window.removeEventListener('orientationchange', setVH);
    };
  }, []);

  const handleMenuClick = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleTabChange = (tab: TabType) => {
    setActiveTab(tab);
  };

  return (
    <div className="fixed inset-0 flex flex-col overflow-hidden" style={{ background: 'var(--main-background)' }}>
      {/* Header */}
      <MobileHeader onMenuClick={handleMenuClick} />
      
      {/* Tabs */}
      <MobileTabs activeTab={activeTab} onTabChange={handleTabChange} />
      
      {/* Main Content */}
      <div className="flex-1 overflow-hidden" style={{ marginTop: '112px' }}>
        {activeTab === 'policies' && (
          <div className="h-full relative">
            <PoliciesTab 
              policies={policies}
              selectedCategory="All"
              onCategoryChange={() => {}}
            />
          </div>
        )}
        {activeTab === 'ai-bot' && (
          <div className="flex flex-col h-full">
            <AIBotTab 
              policies={policies}
              messages={messages}
              setMessages={setMessages}
              inputMessage={inputMessage}
              setInputMessage={setInputMessage}
              typeMessage={typeMessage}
              handleSendMessage={handleSendMessage}
              quickQuestions={quickQuestions}
              scrollPosition={scrollPosition}
              scrollContainerRef={scrollContainerRef}
              scrollQuestions={scrollQuestions}
              chatContainerRef={chatContainerRef}
              isUserScrolling={isUserScrolling}
              shouldAutoScroll={shouldAutoScroll}
              handleScroll={handleScroll}
              scrollToBottom={scrollToBottom}
              isAIReplying={isAIReplying}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default MobileLayout;
